import { Badge } from '../components/ui/badge';
import type { ColumnDef } from '../components/common/DataTable';

/** Minimal row shape the Products cell reads, so the builder stays independent
 *  of the full Creator Content row. */
export type CreatorContentProductRow = {
  assigned_products?: Array<{ product_id: string; name: string; notes?: string }>;
};

/**
 * creatorContentProductsColumns — the gated Products column for the reporting
 * Creator Content table (Multi-Product Campaigns). `showProducts` is the
 * report's `columns.products` flag: the backend decides (>= 2 campaign products,
 * not a Shopify campaign), so the screen and the Excel export always agree.
 * Returns `[]` when the flag is off. Read-only chips (assignment is admin-owned
 * on the roster); identical for brand and admin. Mirrors liveProductsColumns on
 * the Live Content table.
 */
export function creatorContentProductsColumns(
  showProducts: boolean,
): ColumnDef<CreatorContentProductRow>[] {
  if (!showProducts) return [];
  return [
    {
      id: 'products',
      header: 'Products',
      minWidth: 160,
      wrap: true,
      cell: (entry) => {
        const items = entry.assigned_products ?? [];
        if (items.length === 0) {
          return <span className="text-caption-regular text-muted-foreground">—</span>;
        }
        return (
          <div className="flex flex-wrap items-center gap-1">
            {items.map((p) => (
              <Badge key={p.product_id} variant="secondary" title={p.notes || p.name}>
                {p.name}
              </Badge>
            ))}
          </div>
        );
      },
    },
  ];
}
